<script setup>
import { ref } from "vue";
import { mapState } from "vuex";
import { urlMainAPI } from "@/global";
import axios from 'axios';
import GeneralConfigs from './GeneralConfigs'
import CollectedReference from './CollectedReference'
import CalculatedReference from './CalculatedReference'
import Abstract from './Abstract';
import CustomLoading from "../commons/CustomLoading.vue";
import MediatorIndicatorEditor from '../MediatorIndicatorEditor';
</script>
<template>
    <section class="editor-container">
        <CustomLoading v-if="this.loadingSteps.status == true" :msg="this.loadingSteps.msg" />

        <b-tabs fill lazy pills no-nav-style class="structure-container" nav-class="p-0 m-0"
            @activate-tab="handleDisableSelector" v-model="structureIndex">
            <b-tab :title="showRefs == true ? $t('generalConfigs') : $t('manage-indicator')" active>
                <GeneralConfigs :isCreating="isCreating" :allowTab="allowTab" :showRefs="showRefs" />
            </b-tab>
            <b-tab v-if="showRefs == true" :title="$t('collectedReference')"
                :disabled="isCreating && blockStructure.collected">
                <CollectedReference :isCreating="isCreating" :allowTab="allowTab"
                    :selectedIndicator="this.selectedIndicator" @reloadIndicator="chooseIndicator($event)" />
            </b-tab>
            <b-tab v-if="showRefs == true" :title="$t('calculatedReference')"
                :disabled="isCreating && blockStructure.calculated">
                <CalculatedReference :isCreating="isCreating" :allowTab="allowTab"
                    :selectedIndicator="this.selectedIndicator" />
            </b-tab>
            <b-tab :title="$t('abstract')" v-if="isCreating" :disabled="isCreating && blockStructure.abstract">
                <Abstract :isCreating="isCreating" :allowTab="allowTab" :goToTab="backToTab" :showRefs="showRefs" />
            </b-tab>
        </b-tabs>
        <section class="ind-selector" v-if="isCreating == false && showRefs == true">
            <input :disabled="disableSelect" type="search" id="selectorIndicator"
                placeholder="Selecione um indicador..." readonly :value="this.selectedIndicator.indicatorName"
                @click="() => this.$bvModal.show('chooseIndicator')">
            <b-icon-search></b-icon-search>
        </section>

        <b-modal id="chooseIndicator" :title="$t('selecione-um-indicador')" hide-footer>
            <input type="text" v-model="indicatorNameSearch" id="filterSelectorList" ref="indSearch"
                :placeholder="$t('indicator-filter')">
            <section class="ind-list">
                <p v-for="(ind, idx) in this.filterIndicatorList()" :key="`${ind.indicatorId}-${idx}`"
                    @click="() => chooseIndicator(ind)">{{ ind.indicatorName }}</p>
            </section>
        </b-modal>
    </section>
</template>
<script>
export default {
    name: 'TabStructure',
    props: {
        isCreating: Boolean
    },
    emit: [],
    computed: mapState(["user"]),
    components: { CustomLoading },
    data() {
        return {
            blockStructure: {
                collected: true,
                calculated: true,
                abstract: true,
            },
            loadingSteps: { status: false, msg: 'Carregando Informações do Indicador' },
            disableSelect: true,
            structureIndex: 0,
            selectedIndicator: {},
            indicatorsStructureList: [],
            showRefs: true,

            indicatorNameSearch: ref("")
        }
    },
    watch: {
        "blockCollected"() {
            this.structureIndex = 1
        }
    },
    methods: {
        allowTab(tabName) {
            if (this.isCreating == true && MediatorIndicatorEditor.isCreatingRoot == true) {
                this.blockStructure.collected = true
                this.blockStructure.calculated = true
                this.blockStructure.abstract = false
            } else {
                if (MediatorIndicatorEditor.isCreatingRoot == false && this.blockStructure.abstract == false && this.blockStructure.collected == true
                    && this.blockStructure.calculated == true) this.blockStructure.abstract = true

                this.blockStructure[`${tabName}`] = false;
            }
        },

        handleDisableSelector(tabIdx) {
            if (tabIdx == 1 || tabIdx == 2) this.disableSelect = false;
            else this.disableSelect = true;
        },

        backToTab(idx) {
            this.structureIndex = idx;
        },

        filterIndicatorList() {
            return this.indicatorNameSearch != '' && this.indicatorNameSearch != undefined ? this.indicatorsStructureList.filter(item => item.indicatorName.toLowerCase().includes(this.indicatorNameSearch.toLowerCase())) : this.indicatorsStructureList;
        },

        async chooseIndicator(ind) {
            this.$bvModal.hide('chooseIndicator')

            this.loadingSteps.status = true;
            this.loadingSteps.msg = 'Carregando Informações do Indicador';
            let selectingIndicatorObj = { ...ind };

            await axios.get(`${urlMainAPI}/findInformationRealPrevIndicator/${Number(ind.indicatorId)}`)
                .then((res) => {
                    selectingIndicatorObj.realRefs = {
                        equation: [],
                        createdReferences: [],
                    };

                    selectingIndicatorObj.prevRefs = {
                        equation: [],
                        createdReferences: [],
                    };

                    let realRefs = JSON.parse(res.data.Real);
                    let prevRefs = JSON.parse(res.data.Prev);

                    for (let real of realRefs) {
                        let refObj = {};

                        if (real.type && real.type != null) {
                            if (real.type.toLowerCase().includes('input')) {
                                refObj.label = real.infos.inputName;
                                refObj.desc = `Dado de Entrada\nNão Editável`
                                selectingIndicatorObj.realRefs.equation.push({ label: refObj.label, type: 'input', structure: refObj });
                            } else if (real.type == 'op') {
                                selectingIndicatorObj.realRefs.equation.push({ label: real.infos.value, type: 'operation' })
                            } else if (real.type.includes('collector')) {

                                if (real.infos.value == {} || Object.keys(real.infos.value).length == 0) {
                                    selectingIndicatorObj.hasColError = true;
                                    continue;
                                }

                                refObj.collectorBase = `${real.infos.value.origin}-${real.infos.value.agregation}`;
                                refObj.tagname = real.infos.value.tagname;
                                refObj.minSaturation = real.infos.value.valueMin;
                                refObj.maxSaturation = real.infos.value.valueMax;
                                refObj.colName = real.infos.value.indicatorName.replace('ind_', '').replace('real_', '').replace('prev_', '').replace('calc_', '').replace('online', '').replace('Online', '').replaceAll('_', '');
                                refObj.label = refObj.colName;

                                refObj.originalColName = real.infos.value.indicatorName;

                                refObj.select = real.infos.value.select;
                                refObj.from = real.infos.value.from;
                                refObj.where = real.infos.value.where;
                                refObj.oldTag = real.infos.value.tagname;

                                refObj.type = 'collector';

                                refObj.id = `${selectingIndicatorObj.realRefs.createdReferences.length}-collector-${refObj.label}`;

                                refObj.desc = `Coletor\nNome da Tag: ${refObj.tagname}`

                                if (real.type.includes('OPC')) {
                                    refObj.opctagname = real.infos.opctagname;
                                    refObj.oldColTag = real.infos.opctagname;
                                    refObj.host = real.infos.host;
                                    refObj.opcserver = real.infos.opcserver;
                                    refObj.dbname = real.infos.dbname;
                                    refObj.dbid = real.infos.dbid;
                                    refObj.colType = 'opc';

                                    refObj.desc = `Coletor\nTipo de Coleta: ${refObj.colType.toUpperCase()}\nNome da Tag: ${refObj.tagname}\nTag OPC: ${refObj.opctagname}`
                                }

                                else if (real.type.includes('INTELUP')) {
                                    refObj.productionunit = real.infos.productionunit;
                                    refObj.inteluptagname = real.infos.inteluptagname;
                                    refObj.oldColTag = real.infos.inteluptagname;
                                    refObj.tagname = real.infos.tagname;
                                    refObj.id = real.infos.id;
                                    refObj.dbname = real.infos.dbname;
                                    refObj.dbid = real.infos.dbid;
                                    refObj.colType = 'intelup';

                                    refObj.desc = `Coletor\nTipo de Coleta: ${refObj.colType.toUpperCase()}\nNome da Tag: ${refObj.tagname}\nTag Intelup: ${refObj.inteluptagname}`
                                }

                                else if (real.type.includes('PISYSTEM')) {
                                    refObj.tagname = real.infos.tagname;
                                    refObj.pitagname = real.infos.pitagname;
                                    refObj.oldColTag = real.infos.pitagname;
                                    refObj.filter = real.infos.filter.toString();
                                    refObj.id = real.infos.id;
                                    refObj.dbname = real.infos.dbname;
                                    refObj.dbid = real.infos.dbid;
                                    refObj.colType = 'pisystem';

                                    refObj.desc = `Coletor\nTipo de Coleta: ${refObj.colType.toUpperCase()}\nNome da Tag: ${refObj.tagname}\nTag Pisystem: ${refObj.pitagname}`
                                }

                                else if (real.type.includes('WEBSERVICE')) {
                                    refObj.id = real.infos.id;
                                    refObj.tagname = real.infos.tagname;
                                    refObj.description = real.infos.description;
                                    refObj.webserviceName = real.infos.webservice;
                                    refObj.oldColTag = real.infos.webservice;
                                    refObj.corporation = real.infos.corporation;
                                    refObj.equipment = real.infos.equipment;
                                    refObj.material = real.infos.material;
                                    refObj.property = real.infos.property;
                                    refObj.indicator = real.infos.indicator;
                                    refObj.acumulate = real.infos.acumulate.toString();
                                    refObj.average = real.infos.average.toString();
                                    refObj.dbname = real.infos.dbname;
                                    refObj.dbid = real.infos.dbid;

                                    refObj.colType = 'webservice';

                                    refObj.desc = `Coletor\nTipo de Coleta: ${refObj.colType.toUpperCase()}\nNome da Tag: ${refObj.tagname}`
                                }

                                else if (real.type.includes('SAP')) {
                                    refObj.colType = 'sap'
                                    refObj.materialFeature = real.infos.materialFeature ? real.infos.materialFeature : real.infos.value.materialFeature
                                    refObj.tagname = refObj.materialFeature
                                    refObj.center = real.infos.center ? real.infos.center : real.infos.value.center

                                    refObj.desc = `Coletor\nTipo de Coleta: ${refObj.colType.toUpperCase()}\nNome da Tag: ${refObj.materialFeature}\nCód. Unidade: ${refObj.center}`

                                }
                                else if (real.type.includes('GATEC')) {
                                    refObj.colType = 'gatec'
                                    refObj.cod_variavel = real.infos.cod_variavel ? real.infos.cod_variavel : real.infos.value.cod_variavel
                                    refObj.tagname = refObj.cod_variavel

                                    refObj.desc = `Coletor\nTipo de Coleta: ${refObj.colType.toUpperCase()}\nNome da Tag: ${refObj.cod_variavel}`
                                }
                                else if (real.type.includes('PIMS')) {
                                    refObj.colType = 'pims'
                                    refObj.Var_Codigo = real.infos.Var_Codigo ? real.infos.Var_Codigo : real.infos.value.Var_Codigo
                                    refObj.emp_codemp = real.infos.emp_codemp ? real.infos.emp_codemp : real.infos.value.emp_codemp
                                    refObj.SUF_CODIGO = real.infos.SUF_CODIGO ? real.infos.SUF_CODIGO : real.infos.value.SUF_CODIGO
                                    refObj.tagname = refObj.Var_Codigo


                                    refObj.desc = `Coletor\nTipo de Coleta: ${refObj.colType.toUpperCase()}\nNome da Tag: ${refObj.Var_Codigo}\nCód. Unidade: ${refObj.emp_codemp}`

                                    if (refObj.SUF_CODIGO != "") {
                                        refObj.desc += `\nSufixo: ${refObj.SUF_CODIGO}`
                                    }
                                }
                                else {
                                    MediatorIndicatorEditor.customToast(this.$bvToast, 'warning', 'Tag não Encontrado', 'Nome da Tag não encontrado no banco de coleta.');
                                }

                                let foundOnCol = selectingIndicatorObj.realRefs.createdReferences.filter(item => item.tagname == refObj.tagname && item.colType == refObj.colType);

                                if (foundOnCol.length > 0) {
                                    refObj.id = foundOnCol[0].id;
                                    selectingIndicatorObj.realRefs.equation.push({ label: refObj.label, type: 'reference', structure: refObj });
                                } else {
                                    selectingIndicatorObj.realRefs.equation.push({ label: refObj.label, type: 'reference', structure: refObj });
                                    selectingIndicatorObj.realRefs.createdReferences.push(refObj);
                                }

                            } else if (real.type == 'fixed') {
                                refObj.fixedName = 'Valor Fixo'
                                refObj.label = 'Valor Fixo'
                                refObj.value = real.infos.value
                                refObj.type = 'fixed'
                                refObj.id = `${selectingIndicatorObj.realRefs.createdReferences.length}-fixed-${refObj.label}`;

                                refObj.desc = `Valor Fixo\nValor: ${refObj.value}`

                                let foundOnFixed = selectingIndicatorObj.realRefs.createdReferences.filter(item => item.value == refObj.value);

                                if (foundOnFixed.length > 0) {
                                    refObj.id = foundOnFixed[0].id;
                                    selectingIndicatorObj.realRefs.equation.push({ label: refObj.label, type: 'reference', structure: refObj });
                                } else {
                                    selectingIndicatorObj.realRefs.equation.push({ label: refObj.label, type: 'reference', structure: refObj });
                                    selectingIndicatorObj.realRefs.createdReferences.push(refObj);
                                }

                            } else if (real.type == 'calc') {
                                refObj.calcName = real.infos.calcName;
                                refObj.label = real.infos.calcName;
                                refObj.type = 'calc'
                                refObj.calcExp = real.infos.calculateEquation
                                refObj.indicatorId = real.infos.indicatorId
                                refObj.indicatorName = real.infos.indicatorName

                                refObj.desc = `Cálculo Externo\nNão Editável\nExpressão: ${refObj.calcExp}\nIndicador Relacionado: ${refObj.indicatorName}`

                                selectingIndicatorObj.realRefs.equation.push({ label: refObj.label, type: 'calc', structure: refObj });
                            }else if(real.infos && real.infos.value && real.infos.value != '-9999'){
                                refObj.desc = 'Referência Desconhecida'
                                refObj.label = real.infos.value
                                refObj.type = 'outro'
                                selectingIndicatorObj.realRefs.equation.push({ label: refObj.label, type: 'reference', structure: refObj });
                            }
                        }
                    }

                    this.loadingSteps.msg = 'Construindo Equações';

                    for (let prev of prevRefs) {
                        let refObj = {};

                        if (prev.type && prev.type != null) {
                            if (prev.type.toLowerCase().includes('input')) {
                                refObj.label = prev.infos.inputName;
                                refObj.desc = `Dado de Entrada\nNão Editável`
                                selectingIndicatorObj.prevRefs.equation.push({ label: refObj.label, type: 'input', structure: refObj });
                            } else if(prev.type.toLowerCase().includes('collector')) {
                                refObj.label = prev.infos.value.indicatorName;
                                refObj.desc = `Coletor Real.\nEditar na Referência Real\nDetalhes:\n`

                                if(prev.type.toLowerCase().includes('opc')) refObj.desc += `Tag OPC: ${prev.infos.opctagname}\nNome do Coletor: ${prev.infos.value.tagname}`
                                if(prev.type.toLowerCase().includes('intelup')) refObj.desc += `Tag Intelup: ${prev.infos.inteluptagname}\nNome do Coletor: ${prev.infos.value.tagname}`
                                if(prev.type.toLowerCase().includes('pisystem')) refObj.desc += `Tag PiSystem: ${prev.infos.pitagname}\nNome do Coletor: ${prev.infos.value.tagname}`
                                
                                selectingIndicatorObj.prevRefs.equation.push({ label: refObj.label, type: 'input', structure: refObj });
                            } else if (prev.type == 'op') {
                                selectingIndicatorObj.prevRefs.equation.push({ label: prev.infos.value, type: 'operation' })
                            } else if (prev.type == 'calc') {
                                refObj.calcName = prev.infos.calcName;
                                refObj.label = prev.infos.calcName;
                                refObj.type = 'calc'
                                refObj.calcExp = prev.infos.calculateEquation
                                refObj.indicatorId = prev.infos.indicatorId
                                refObj.indicatorName = prev.infos.indicatorName
                                refObj.status = prev.infos.status

                                refObj.desc = `Cálculo Externo\nNão Editável\nExpressão: ${refObj.calcExp}\nIndicador Relacionado: ${refObj.indicatorName}`

                                selectingIndicatorObj.prevRefs.equation.push({ label: refObj.label, type: 'calc', structure: refObj });
                            } else if (prev.type.toLowerCase() == 'reference' || prev.type == 'fixed') {
                                refObj.fixedName = 'Valor Fixo'
                                refObj.label = 'Valor Fixo'
                                refObj.value = prev.infos.value
                                refObj.type = 'fixed'
                                refObj.id = `${selectingIndicatorObj.prevRefs.createdReferences.length}-fixed-${refObj.label}`;

                                refObj.desc = `Valor Fixo\nValor: ${refObj.value}`

                                let foundOnFixed = selectingIndicatorObj.prevRefs.createdReferences.filter(item => item.value == refObj.value);

                                if (foundOnFixed.length > 0) {
                                    refObj.id = foundOnFixed[0].id;
                                    selectingIndicatorObj.prevRefs.equation.push({ label: refObj.label, type: 'reference', structure: refObj });
                                } else {
                                    selectingIndicatorObj.prevRefs.equation.push({ label: refObj.label, type: 'reference', structure: refObj });
                                    selectingIndicatorObj.prevRefs.createdReferences.push(refObj);
                                }

                            } else if (prev.type == 'cr') {
                                refObj.map = prev.infos.value
                                refObj.label = prev.infos.value
                                refObj.type = 'gemeo'
                                refObj.id = `${selectingIndicatorObj.prevRefs.createdReferences.length}-gemeo`

                                let foundOnMap = selectingIndicatorObj.prevRefs.createdReferences.filter(item => item.map == refObj.map);

                                if (foundOnMap.length > 0) {
                                    refObj.id = foundOnMap[0].id;
                                    selectingIndicatorObj.prevRefs.equation.push({ label: refObj.label, type: 'reference', structure: refObj });
                                } else {
                                    selectingIndicatorObj.prevRefs.equation.push({ label: refObj.label, type: 'reference', structure: refObj });
                                    selectingIndicatorObj.prevRefs.createdReferences.push(refObj);
                                }
                            } else if (prev.type == 'plan') {
                                refObj.label = prev.infos.value
                                refObj.type = 'plan'
                                selectingIndicatorObj.prevRefs.equation.push({ label: refObj.label, type: 'reference', structure: refObj });

                            } else if (prev.type == 'generalResult' && prev.infos.value != '-9999') {
                                selectingIndicatorObj.idealRes = prev.infos.value
                            }else if(prev.type != 'generalResult' && prev.infos && prev.infos.value && prev.infos.value != '-9999'){
                                refObj.desc = 'Referência Desconhecida'
                                refObj.label = prev.infos.value
                                refObj.type = 'outro'
                                selectingIndicatorObj.prevRefs.equation.push({ label: refObj.label, type: 'reference', structure: refObj });
                            }
                        }
                    }

                }).catch((err) => console.log(err))

            this.selectedIndicator = { ...selectingIndicatorObj };

            await MediatorIndicatorEditor.getCollectorBases();
            await MediatorIndicatorEditor.generateMapObj();
            await MediatorIndicatorEditor.getProductionPlanData();

            this.loadingSteps.status = false;

        },
    },

    async created() {
        this.loadingSteps.status = true;
        this.loadingSteps.msg = 'Construindo Interface';
        this.indicatorsStructureList = MediatorIndicatorEditor.indicatorsList;
        await MediatorIndicatorEditor.getIndicatorsList().then(res => {
            if(res.length > 0){
                this.indicatorsStructureList = [...res];
            }
        }).catch(err => console.error(err));
        
        if (this.user.Permissions.editordeindicadores) {
            if (this.user.Permissions.editordeindicadores.parameter) {
                if (this.user.Permissions.editordeindicadores.parameter.toLowerCase() == 'drp') {
                    this.showRefs = false;
                }
            }
        }
        this.loadingSteps.status = false;
    },


    beforeDestroy() {
        MediatorIndicatorEditor.clearMemory();
    }
}
</script>
<style scoped>
@import '../commons/commonStyles.css';

.editor-container {
    height: 70vh;
}

.tab-pane {
    height: 100%;
}

.custom-border-editor {
    border-bottom-color: #000;
}

.editor-tab-content {
    min-height: 100%;
    border: 1px solid #00A39F;
}

.ind-selector {
    position: absolute;
    top: 0.8rem;
    right: 1rem;
    width: 20rem;

    border: 1px solid #FF5F00;
    border-radius: 0.3rem;
    padding: 0.2rem 0.4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.ind-selector input {
    background-color: transparent;
    border: none !important;
    width: 100%;
    cursor: pointer;
}

.ind-selector:has(input[disabled="disabled"]) {
    background-color: #dbdbdb;
    filter: grayscale(100%);
    cursor: not-allowed;
}

.ind-selector:has(input[disabled="disabled"]) input {
    cursor: not-allowed;
}

.ind-selector:has(input[disabled="disabled"]) input::placeholder {
    color: #a1a1a1;
}

.ind-selector input:focus {
    box-shadow: none !important;
}

.ind-list {
    max-height: 65vh;
    overflow-y: auto;
}

.ind-list p {
    margin: 0;
    cursor: pointer;
    padding: 0.8rem 0.2rem;
}

.ind-list p:hover {
    background-color: #8d8d8d21;
}

#filterSelectorList {
    width: 100%;
    border: 1px solid #FF5F00;
    border-radius: 0.2rem;
    padding: 0.3rem;
    margin-bottom: 0.8rem;
}

.disableSelect {
    background-color: aqua;
}

@media (min-height: 900px) {
    .editor-container {
        height: 77vh;
    }
}
</style>